import { siteStats } from "@/mocks/site";

export default function StatsStrip() {
  return (
    <section className="relative z-10 -mt-14 w-full md:-mt-16">
      <div className="mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="grid grid-cols-2 gap-y-8 rounded-xl border border-background-200 bg-background-50 px-6 py-8 md:grid-cols-4 md:px-10 md:py-10">
          {siteStats.map((stat, index) => (
            <div
              key={stat.label}
              className={`px-2 md:px-4 ${index !== 0 ? "md:border-l md:border-background-200" : ""}`}
            >
              <p className="font-heading text-2xl font-bold text-primary-600 md:text-4xl">{stat.value}</p>
              <p className="mt-2 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}